/* eslint-disable no-irregular-whitespace */
import * as React from 'react';
import {
  Button,
  Checkbox,
  Chips,
  InputAdornment,
  MaskedInput,
  Select,
  UIHeading1,
  UIHeading4,
  UIText1,
  UIText3,
} from '@cian/ui-kit';
import { IFormProps } from 'shared/containers/forms/hooks/useFormProps';
import { CONSENT_PERSONAL_DATA, MARKETING_AGREEMENT, PRIVACY_POLICY } from 'shared/constants/constants';
import * as styles from './styles.css';

const CODE_MASK = '(000) 000 00-00';

export const FormModal: React.FC<IFormProps> = ({
  dealTypeValue,
  dealTypeOptions,
  dealTypeChange,
  phoneValue,
  onPhoneChange,
  regionValue,
  regionOptions,
  onRegionChange,
  onSubmit,
  legalAgreementAccepted,
  onLegalAgreementChange,
  source,
  errors,
}) => {
  const messages =
    source === 'consultation'
      ? {
          title: <UIHeading1 color="text-primary-default">Остались вопросы? Мы готовы ответить</UIHeading1>,
          subtitle: <UIText1 color="text-primary-default">Перезвоним и поможем во всём разобраться</UIText1>,
          cta: 'Позвоните мне',
          source: 'seoLandingPageConsultation' as const,
        }
      : {
          title: <UIHeading1 color="text-primary-default">Оставьте заявку на подбор риелтора</UIHeading1>,
          subtitle: <UIText1 color="text-primary-default">Уточним детали и начнём подбор</UIText1>,
          cta: 'Перезвоните мне',
          source: 'seoLandingPageForm' as const,
        };

  return (
    <div data-testid="FormModal" className={styles['container']}>
      <div>
        {messages.title}
        {messages.subtitle}
      </div>

      <div className={styles['form']}>
        <div className={styles['form-item']}>
          <UIHeading4 as="p">С чем нужна помощь?</UIHeading4>
          <Chips
            value={dealTypeValue}
            options={dealTypeOptions}
            selectType="single"
            onChipClick={dealTypeChange}
            size="M"
            invalid={!!errors?.dealTypeError}
          />
          {!!errors?.dealTypeError && <UIText3 color="text-negative-default">{errors.dealTypeError}</UIText3>}
        </div>

        <div className={styles['form-item']}>
          <UIHeading4 as="p">В каком регионе?</UIHeading4>
          <Select
            value={regionValue}
            options={regionOptions}
            onChange={onRegionChange}
            size="M"
            placeholder="Выберите регион"
            invalid={!!errors?.regionError}
          />
          {!!errors?.regionError && <UIText3 color="text-negative-default">{errors.regionError}</UIText3>}
        </div>

        <div className={styles['form-item']}>
          <UIHeading4 as="p">На какой номер перезвонить?</UIHeading4>
          <MaskedInput
            leftAdornment={<InputAdornment>+7</InputAdornment>}
            value={phoneValue}
            onChange={onPhoneChange}
            lazy
            size="M"
            mask={CODE_MASK}
            placeholder="Номер телефона"
            invalid={!!errors?.phoneError}
          />
          {!!errors?.phoneError && <UIText3 color="text-negative-default">{errors.phoneError}</UIText3>}
        </div>
      </div>

      <Button theme="fill_primary" size="M" onClick={() => onSubmit(messages.source)}>
        {messages.cta}
      </Button>

      <div className={styles['link-item']}>
        <Checkbox
          checked={legalAgreementAccepted}
          onChange={onLegalAgreementChange}
          label={
            <UIText3 color="text-secondary-default">
              Соглашаюсь на{' '}
              <a href={MARKETING_AGREEMENT} className={styles['link']} target="_blank" rel="noopener noreferrer">
                рассылки и звонки
              </a>
            </UIText3>
          }
        />
      </div>

      <div className={styles['link-item']}>
        <UIText3 color="text-secondary-default">
          {`Нажимая «${messages.cta}», я даю`}{' '}
          <a href={CONSENT_PERSONAL_DATA} target="_blank" className={styles['link']} rel="noreferrer">
            Согласие на обработку персональных данных
          </a>{' '}
          в соответствии с{' '}
          <a href={PRIVACY_POLICY} target="_blank" className={styles['link']} rel="noreferrer">
            Политикой конфиденциальности
          </a>
        </UIText3>
      </div>
    </div>
  );
};
